module.exports = __webpack_public_path__ + "static/media/clube.04c38bad.svg";